import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { ActionsBarRight } from '../ActionsBarRight';
import { ConnectedActionsBarCenter } from '../ActionsBarCenter/container';
import { ActionsBarLeftContainer } from '../ActionsBarLeft/container';
import { useSessionUserContext } from '../../../../../../hooks/use-session-user-context';
import styles from './ActionsBar.module.css';

export function ActionsBar(): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();

  return (
    <div className={classNames('header', styles.root)}>
      <div className="header-panels dbl-padding-left dbl-padding-right">
        <ActionsBarLeftContainer
          accessKey={accessKey}
          sessionUid={sessionUid}
          versionUid={versionUid}
        />
        <ConnectedActionsBarCenter />
        <ActionsBarRight />
      </div>
    </div>
  );
}
